import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignTopThreadSourcesLoadAction } from '../../domains/campaignTopThreadSources/actions.types';

import { CampaignTopThreadSourcesLifecycle } from './types';

const initialState: CampaignTopThreadSourcesLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<CampaignTopThreadSourcesLifecycle, CampaignTopThreadSourcesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'CAMPAIGN_TOP_THREAD_SOURCES.LOAD_PENDING':
      return setPending();
    case 'CAMPAIGN_TOP_THREAD_SOURCES.LOAD_FULFILLED':
      return setFulfilled({
        campaignTopThreadSourceDetails: action.payload.entities.campaignTopThreadSourceDetails,
        campaignTopThreadSourceNumbers: action.payload.entities.campaignTopThreadSourceNumbers,
      });
    case 'CAMPAIGN_TOP_THREAD_SOURCES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
